// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Franquias_SetAtivoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Resposta de /franquias/setAtivo (chamado 2026-0023).
 *
 * Devolve o estado que ficou gravado, e nao um "ok" mudo: a tela redesenha a linha
 * com isto, entao o que ela mostra e o que o banco diz.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Franquias_SetAtivoResponseDados {
franquia_id: number
ativo: boolean
}

export type Franquias_SetAtivoResponse = ApiResponse<Franquias_SetAtivoResponseDados>;

registerResponseContract('Franquias_SetAtivoResponse', {
  franquia_id: { type: 'number',  required: true },
  ativo:       { type: 'boolean', required: true },
})
